import React from "react";
import DetailedGigPage from "./DetailedGigPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface DetailedGigPageContainerProps extends RouteProps, withValidUserRoleProps {}

const DetailedGigPageContainer = (props: DetailedGigPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <DetailedGigPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(DetailedGigPageContainer);
